import * as React from "react";
import { useSelector } from "react-redux";
import {
  DashboardMenuItem,
  MenuItemLink,
  useResourceDefinitions,
} from "react-admin";

import DashboardIcon from "@mui/icons-material/Home";
import CategoryIcon from "@mui/icons-material/Category";
import ComposeIcon from "@mui/icons-material/Schema";
import DeveloperIcon from "@mui/icons-material/DeveloperMode";
import CatalogIcon from "@mui/icons-material/LibraryBooks";
import ConfigIcon from "@mui/icons-material/Settings";
import AnalyticsIcon from "@mui/icons-material/Analytics";
import AssessmentIcon from "@mui/icons-material/Assessment";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useLocation, useNavigate } from "react-router";
import { useEffect, useState } from "react";
import AppExtensionProviderRegistry, {
  AppExtension,
} from "../../framework/app/app.extension.provider";
import {
  Collapse,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
} from "@mui/material";

const CakeMenu = ({ onMenuClick, logout }) => {
  const excludedResources = [
    "theme",
    "environment",
    "dashboard",
    "category",
    "item",
  ];

  const resources = useResourceDefinitions();
  const allResourcecs = Object.keys(resources);
  const tenant = sessionStorage.getItem("current-tenant");
  const brand = sessionStorage.getItem("current-brand");
  const navigate = useNavigate();
  const location = useLocation();
  const appExtension: AppExtension =
    AppExtensionProviderRegistry.getDefaultProvider()?.getAppExtension();
  const defaultRoute = appExtension.getDefaultRoute();
  const [dataOpen, setDataOpen] = useState(false);
  const [aiOpen, setAiOpen] = useState(false);

  const handleDataClick = () => {
    // Navigate to the "Data" section and toggle the collapse state
    navigate("/data");
    setDataOpen(!dataOpen);
  };

  const handleAIClick = () => {
    // Navigate to the "Data" section and toggle the collapse state
    navigate("/ai");
    setAiOpen(!aiOpen);
  };

  const ResourceSubMenuItem = ({ resourceName, onClick }) => {
    const resources = useResourceDefinitions();
    const resource = resources[resourceName];

    if (!resource) {
      return null; // If the resource doesn't exist, don't render anything
    }

    return (
      <SubMenuItem
        to={`/${resourceName}`}
        label={resource?.options?.label || resourceName}
        Icon={resource?.icon || React.Fragment} // Use a default icon if none is provided
        onClick={onClick}
      />
    );
  };

  const SubMenuItem = ({
    to,
    label,
    Icon,
    onClick,
    padding = 32,
    fontSize = "0.875rem",
  }) => (
    <MenuItemLink
      to={to}
      primaryText={label}
      leftIcon={<Icon style={{ fontSize: "20px" }} />} // Smaller icon
      onClick={onClick}
      style={{
        paddingLeft: `${padding}px`,
        fontSize: fontSize,
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
      }}
    />
  );

  if (!tenant && allResourcecs && allResourcecs.length) {
    return (
      <div>
        <MenuItemLink
          key="tenant"
          to={`/tenant`}
          primaryText={
            (resources["tenant"].options &&
              resources["tenant"].options.label) ||
            "tenant"
          }
          leftIcon={
            resources["tenant"].icon ? (
              React.createElement(resources["tenant"].icon)
            ) : (
              <CategoryIcon />
            )
          }
          onClick={onMenuClick}
        />
        {logout}
      </div>
    );
  }

  return (
    <div>
      <MenuItemLink to="/" primaryText="Welcome" leftIcon={<DashboardIcon />} />

      <MenuItemLink
        key={"application"}
        to={`/application`}
        primaryText={
          (resources["application"]?.options &&
            resources["application"]?.options?.label) ||
          "application"
        }
        leftIcon={
          resources["application"]?.icon ? (
            React.createElement(resources["application"]?.icon)
          ) : (
            <CategoryIcon />
          )
        }
        onClick={onMenuClick}
      />

      <ListItem onClick={handleAIClick}>
        <ListItemIcon style={{ minWidth: "40px" }}>
          <ConfigIcon />
        </ListItemIcon>
        <ListItemText primary="AI" style={{ textAlign: "left" }} />
        {aiOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
      </ListItem>

      {/* Nested Menu Items */}
      <Collapse
        in={aiOpen}
        timeout="auto"
        unmountOnExit
        style={{ paddingLeft: "10px" }}
      >
        <Paper
          elevation={2}
          style={{
            width: "95%",
            marginLeft: "10px", // Added padding inside the Paper for better spacing
            borderRadius: "8px", // Ensure rounded corners
          }}
        >
          <List component="div" disablePadding>
            <ResourceSubMenuItem
              resourceName="aiassistant"
              onClick={onMenuClick}
            />
            <ResourceSubMenuItem
              resourceName="aifileinstance"
              onClick={onMenuClick}
            />
          </List>
        </Paper>
      </Collapse>

      {/* Analytics menu item hidden */}
      {/* <MenuItemLink
        to="/analytics"
        primaryText="Analytics"
        leftIcon={<AnalyticsIcon />}
        onClick={onMenuClick}
      /> */}

      <MenuItemLink
        to="/reports"
        primaryText="Reports"
        leftIcon={<AssessmentIcon />}
        onClick={onMenuClick}
      />

      <MenuItemLink
        to="/developer"
        primaryText="Developer"
        leftIcon={<DeveloperIcon />}
        onClick={onMenuClick}
      />
      <MenuItemLink
        to="/compose"
        primaryText="Integration"
        leftIcon={<ComposeIcon />}
        onClick={onMenuClick}
      />

      <ListItem onClick={handleDataClick}>
        <ListItemIcon style={{ minWidth: "40px" }}>
          <ConfigIcon />
        </ListItemIcon>
        <ListItemText primary="Data" style={{ textAlign: "left" }} />
        {dataOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
      </ListItem>

      {/* Nested Menu Items */}
      <Collapse
        in={dataOpen}
        timeout="auto"
        unmountOnExit
        style={{ paddingLeft: "10px" }}
      >
        <Paper
          elevation={2}
          style={{
            width: "95%",
            marginLeft: "10px", // Added padding inside the Paper for better spacing
            borderRadius: "8px", // Ensure rounded corners
          }}
        >
          <List component="div" disablePadding>
            <ResourceSubMenuItem
              resourceName="location"
              onClick={onMenuClick}
            />

            <ResourceSubMenuItem resourceName="person" onClick={onMenuClick} />
            <SubMenuItem
              to="catalog"
              label="Menu"
              Icon={CatalogIcon}
              onClick={onMenuClick}
            />
            <ResourceSubMenuItem
              resourceName="customer"
              onClick={onMenuClick}
            />
            <ResourceSubMenuItem
              resourceName="case"
              onClick={onMenuClick}
            />
          </List>
        </Paper>
      </Collapse>

      {logout}
    </div>
  );
};

export default CakeMenu;

/*
     import * as React from "react";
import { MenuItemLink, useResourceDefinitions } from "react-admin";
import CategoryIcon from "@mui/icons-material/Category";

import AnalyticsIcon from "@mui/icons-material/Analytics";
import WelcomeIcon from "@mui/icons-material/PlayCircleFilled"
import ConfigurationIcon from "@mui/icons-material/Settings";

import ComposeIcon from "@mui/icons-material/Schema";
import DeveloperIcon from "@mui/icons-material/DeveloperMode";

import { useLocation, useNavigate } from "react-router";
import { useEffect } from "react";

const CakeMenu = ({ onMenuClick, logout }) => {
  const resources = useResourceDefinitions();
  const allResourcecs = Object.keys(resources);
  const tenant = sessionStorage.getItem("current-tenant");
  const brand = sessionStorage.getItem("current-brand");

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Check if the current path is '/'
    if (location.pathname === "/tenant") {
      // Navigate to your custom route
      navigate("/welcome", { replace: true });
    }
  }, [location, navigate]);

  return (
    <div>
       <MenuItemLink
        to="/"
        primaryText="Welcome"
        leftIcon={<WelcomeIcon />}
        onClick={onMenuClick}
      />
      <MenuItemLink
        to="/analytics"
        primaryText="Analytics"
        leftIcon={<AnalyticsIcon />}
        onClick={onMenuClick}
      />
      {brand && (
        <MenuItemLink
          key={"location"}
          to={`/location`}
          primaryText={
            (resources["location"]?.options &&
              resources["location"]?.options?.label) ||
            "location"
          }
          leftIcon={
            resources["location"]?.icon ? (
              React.createElement(resources["location"]?.icon)
            ) : (
              <CategoryIcon />
            )
          }
          onClick={onMenuClick}
        />
      )}
      {brand && (
        <MenuItemLink
          key={"person"}
          to={`/person`}
          primaryText={
            (resources["person"]?.options &&
              resources["person"]?.options?.label) ||
            "person"
          }
          leftIcon={
            resources["person"]?.icon ? (
              React.createElement(resources["person"]?.icon)
            ) : (
              <CategoryIcon />
            )
          }
          onClick={onMenuClick}
        />
      )}
      {brand && (
        <MenuItemLink
          key={"customer"}
          to={`/customer`}
          primaryText={
            (resources["customer"]?.options &&
              resources["customer"]?.options?.label) ||
            "customer"
          }
          leftIcon={
            resources["customer"]?.icon ? (
              React.createElement(resources["customer"]?.icon)
            ) : (
              <CategoryIcon />
            )
          }
          onClick={onMenuClick}
        />
      )}
      <MenuItemLink
        to="/config"
        primaryText="Configuration"
        leftIcon={<ConfigurationIcon />}
        onClick={onMenuClick}
      />
      {brand && (
        <MenuItemLink
          key={"case"}
          to={`/case`}
          primaryText={
            (resources["case"]?.options && resources["case"]?.options?.label) ||
            "customer"
          }
          leftIcon={
            resources["case"]?.icon ? (
              React.createElement(resources["case"]?.icon)
            ) : (
              <CategoryIcon />
            )
          }
          onClick={onMenuClick}
        />
      )}
       <MenuItemLink
                to="/developer"
                primaryText="Developer"
                leftIcon={<DeveloperIcon />}
                onClick={onMenuClick}
            />
           <MenuItemLink
                to="/compose"
                primaryText="Integration"
                leftIcon={<ComposeIcon />}
                onClick={onMenuClick}
            />
      {logout}
    </div>
  );
};

export default CakeMenu;
                  */
